import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useDeleteHook from "../../customHooks/useDeleteHook";
import StatusIcon from "../../Icons/StatusIcon";
import Spinner from "../../Components/Reusable/Spinner";
const DataCollectionComponent = loadable(
  () => import("../../Components/DataCollection/DataCollection")
);
const DataCollectionList = () => {
  const { data, isLoading } = useGetHook({
    queryKey: ["data-collect"],
    url: `${APIS.FORM_DATA}`,
    params: {},
  });

  const { mutateAsync } = useDeleteHook({
    queryKey: ["data-collect"],
    navigateURL: "",
  });

  const handleDelete = async (setIsOpen: any, id: any) => {
    const url = `${APIS.FORM_DATA}${id}/`;
    try {
      const res = await mutateAsync({ url });
      if (res?.status === 204) {
        setIsOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <>
        <div
          className={tw`w-full flex justify-left gap-x-2 uppercase font-extrabold items-center`}
        >
          <StatusIcon />
          <span className={tw`text-[#5E5757] font-bold text-xl`}>
            News Letter
          </span>
        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <DataCollectionComponent data={data} handleDelete={handleDelete} />
        )}
      </>
    </>
  );
};

export default DataCollectionList;
